const canvas = document.getElementById('scratch-canvas');
const container = document.querySelector('.scratch-to-see');
const ctx = canvas.getContext('2d');

canvas.setAttribute('width', canvas.parentElement.clientWidth);
canvas.setAttribute('height', canvas.parentElement.clientHeight);

drawImage();

function drawImage() {
  const image = new Image(canvas.parentElement.clientWidth, canvas.parentElement.clientHeight);
  image.src = '/cdn/shop/t/65/assets/scratch-card.png?v=113587334314182184061772443755';
  image.crossOrigin = 'anonymous';
  image.onload = () => {
    ctx.drawImage(image, 0, 0, image.width, image.height);
    ctx.globalCompositeOperation = 'destination-out';
  };
}

const BRUSH_RADIUS = 20;
const SAMPLE_STRIDE = 4;
let isDrawing = false;
let lastPos = null;

function drawStroke(from, to) {
  ctx.save();
  ctx.beginPath();
  ctx.lineCap = 'round';
  ctx.lineJoin = 'round';
  ctx.lineWidth = BRUSH_RADIUS * 2;
  ctx.moveTo(from.x, from.y);
  ctx.lineTo(to.x, to.y);
  ctx.stroke();
  // endpoint circle to ensure no gaps
  ctx.beginPath();
  ctx.arc(to.x, to.y, BRUSH_RADIUS, 0, Math.PI * 2);
  ctx.fill();
  ctx.restore();
}

function getPosFromEvent(e) {
  const evt = (e.touches && e.touches[0]) || e;
  const bounds = canvas.getBoundingClientRect();
  return {
    x: evt.clientX - bounds.left,
    y: evt.clientY - bounds.top
  };
}

function onPointerDown(e) {
  e.preventDefault();
  document.querySelector('.unlock-gift__scratch-area > img').style.opacity = '1';
  isDrawing = true;
  lastPos = getPosFromEvent(e);
  drawStroke(lastPos, lastPos);
}

function onPointerMove(e) {
  if (!isDrawing) {
    return;
  }
  e.preventDefault();
  const pos = getPosFromEvent(e);
  drawStroke(lastPos, pos);
  lastPos = pos;
  checkCleared();
}

function onPointerUp(e) {
  if (!isDrawing) {
    return;
  }
  isDrawing = false;
}

function checkCleared() {
  const w = canvas.width;
  const h = canvas.height;

  const img = ctx.getImageData(0, 0, w, h);
  const data = img.data;

  let cleared = 0;
  let total = 0;

  for (let y = 0; y < canvas.height; y += SAMPLE_STRIDE) {
    for (let x = 0; x < canvas.width; x += SAMPLE_STRIDE) {
      const idx = (y * canvas.width + x) * 4;
      const alpha = data[idx + 3];
      total++;
      if (alpha === 0) cleared++;
    }
  }

  const ratio = cleared / total;
  if (ratio >= 0.3) {
    reveal();
    isDrawing = false;
  }
}

// const claimButton = document.querySelector('.scratch-to-see__button');
// const instructionsEl = document.querySelector('.scratch-card__instructions');
// const noticeEl = document.querySelector('.scratch-to-see__notice');

function reveal() {
  canvas.style.pointerEvents = 'none';
  canvas.style.transition = 'opacity 1000ms ease';
  canvas.style.opacity = '0';

  confetti({
    particleCount: 100,
    spread: 70,
    origin: { y: 0.6 },
  });

  container.classList.add('scratch-to-see__opened');
  // claimButton.classList.remove('hidden');
  // noticeEl.classList.remove('hidden');
  // instructionsEl.classList.add('hidden');
  setTimeout(() => canvas.remove(), 1000);
}

canvas.addEventListener('mousedown', onPointerDown);
canvas.addEventListener('mousemove', onPointerMove);
window.addEventListener('mouseup', onPointerUp);
canvas.addEventListener('touchstart', onPointerDown, {passive:false});
canvas.addEventListener('touchmove', onPointerMove, {passive:false});
window.addEventListener('touchend', onPointerUp);